import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as USER_STATUS_TYPE} from '../creators/user.status';

export function* createSuccess(action) {
    try {
        yield put({type: "USER_TIMELINES_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "USER_TIMELINES_DELETE", data : action.payload});

    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "USER_TIMELINES_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchTimelineStatus() {
    yield takeEvery(USER_STATUS_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(USER_STATUS_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(USER_STATUS_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchTimelineStatus;

